
import Footer from "./Footer";
import Service from "./Service";
export default function HeaderService() {
  return (
    <div>
     
       <Service />
      <Footer /> 
    </div>
  );
}
